import React, { useState, useEffect } from 'react';
import { Tree, Empty, Spin, Input } from 'antd';
import { CaretDownOutlined, FileTextOutlined, FolderOpenOutlined, FolderOutlined, SearchOutlined} from '@ant-design/icons';


import storage from "../../../../utils/storage";
import Api from "../../../../api";
import "./index.scss";

let defalutPolicyThemeList = [];
const OverseasCasesTree = ({overseasChange}) => {
    const [searchNav, setSearchNav] = useState([
        {value:"2", label:"地点", tips:"搜索地点或项目名称"},
        {value:"1", label:"年份", tips:"搜索项目年份"},
        {value:"3", label:"阶段", tips:"搜索项目阶段"}
    ]);
    const [active, setActive] = useState('2');

    const [selectedKeys, setSelectedKeys] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [searchValue, setSearchValue] = useState('');

    const [treeDate, setTreeDate] = useState("");
    const [tips, setTips] = useState('搜索地点或项目名称');
    const [treeSpinning, setTreeSpinning] = useState(false);
    const [expandedKeyList, setExpandedKeyList] = useState([]);
    let expandedKeys = [];

    useEffect(() => { 
        getpolicyTree();
    }, [active,searchText])

    const switchMav = (item) => {
        setSearchValue('');
        setSearchText('');
        setTips(item.tips);
        setActive(item.value);
    }

    const getpolicyTree = async () => {
        setTreeSpinning(true);
        setTreeDate([]);
        try {
            let res = await Api.Knowledge.selectOct({
                data: {
                    departmentId: storage.getItem("userInfo").departmentId,
                    tagClassId:active,
                    octName:searchText
                }
            });
            setTreeSpinning(false);
            
            if (res && res.code === 0 && res.data) {
                let _data = res.data;
                let newData = [];

                _data.map(item=>{
                    let _datas = item.children.map(childrenItem=>{
                        return {
                            ...childrenItem,
                            parentId: item.tagValue,
                            updateStutas: true,
                        }
                    })
                    newData.push({
                        octName:item.tagValue,
                        id:item.tagValue,
                        tagIdOctIdStr:item.tagValue,
                        children:_datas,
                        type:0,
                        parentId:0,
                        selectable:false,
                    })
                })
                
                setTreeDate(newData);
                
                getFirstOverseasCaseF(newData[0]);


                // 没有选中任何数据的时候，默认选中第一个
                if(selectedKeys.length <= 0){
                    let firstNode = firstPolicy(newData);
                    setSelectedKeys([firstNode.id])
                    overseasChange({
                        "overseasCaseTypeId":firstNode.id
                    })
                }

                console.log(expandedKeys,"expandedKeys")

                if(expandedKeys.length > 0){
                    setExpandedKeyList(expandedKeys)
                }

            }else{setTreeDate([])}
        } catch (errInfo) {
            setTreeDate([]);
            setTreeSpinning(false);
            console.log('验证失败:', errInfo);
        }
    }
    // 高亮显示第一个主题节点
    function firstPolicy (list) {
        for (const item of list) {
            if (String(item.type) === "1") {
                return item;
            } else if (item.children?.length > 0) {
                return firstPolicy(item.children);
            }
        }
        return undefined;
    }

    const getFirstOverseasCaseF = (data) => {
        expandedKeys.push(data.id);
        if(data.children?.length > 0){
            getFirstOverseasCaseF(data.children[0]);
        }
    }

    const onSelect = (selectedKeys, e) => {
        const node = e.node;
        setSelectedKeys(selectedKeys)
        overseasChange({
            "overseasCaseTypeId":selectedKeys[0]
        })
        console.log(node,selectedKeys)
    }

    const titleRender = (nodeData) => {
        const domId = `nodeId-${nodeData.id}`;
        return (
            <span id={domId} style={{whiteSpace: "pre-wrap", wordBreak: "break-all",}}>
                {nodeData.octName}
                {nodeData.count ? `(${nodeData.count})`: ""}
            </span>
        );
    }

    const handleChange = (e) => {
        if(!e.target.value){
            setSearchText(e.target.value);
        }
        setSearchValue(e.target.value);
    };

    const handleSearch = () => { 
        setSearchText(searchValue);
    };

    const onExpand = (expandedKeys, e) => {
        console.log(expandedKeys, e,"expandedKeys, e")
        let id = e.node.id;
        if(e.expanded){
            let _expandedKeys = [...expandedKeys,id]
            setExpandedKeyList(_expandedKeys);
        }else{
             let _expandedKeys = expandedKeys.filter((item) => {
                return item != id
            });
            console.log(_expandedKeys,"_expandedKeys")
            setExpandedKeyList(_expandedKeys)
        }
    }

    return(
        <div className="overseasCasesTreeFrameV7">

            <div className="searchNav">
                {searchNav.map((item, index) => (
                    <div className={`searchNavItem ${active === item.value ? 'active' : ''}`} key={item.value} onClick={()=>switchMav(item)}>{item.label}</div>
                ))}
            </div>

            <Input
                placeholder={tips}
                prefix={<SearchOutlined />}
                style={{width: '100%',marginBottom: '0.5rem'}}
                allowClear={true}
                onChange={handleChange}
                value={searchValue}
                onPressEnter={handleSearch}
            />
            <Spin spinning={treeSpinning}>
            {
                treeDate && treeDate.length > 0 ?
                    (
                        <Tree
                            showIcon={true}
                            icon={(item) => {
                                const isTheme = String(item.type) === "1";
                                return isTheme ? <FileTextOutlined /> : (item.expanded ? <FolderOpenOutlined /> : <FolderOutlined />);
                            }}
                            switcherIcon={<CaretDownOutlined />}
                            treeData={treeDate}
                            onSelect={onSelect}
                            titleRender={titleRender}
                            onExpand={onExpand}
                            selectedKeys={selectedKeys}
                            expandedKeys={[...expandedKeyList]}
                            blockNode
                            fieldNames={{
                                title:"octName",
                                key: "id",
                                children:"children",
                                isLeaf:"type",
                            }}
                        />
                    )
                    :
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            }
            </Spin>
        </div>
    )
}

export default OverseasCasesTree;
